import React, { Component } from 'react';

import { Page, Button, Card } from '@shopify/polaris';

// import OnPageSEOTabs from '../Tabs';
// https://cdn.shopifycloud.com/web/assets/6933fb5939cd87752c68648f5db4d540.svg
import notFoundImg from './images/6933fb5939cd87752c68648f5db4d540.svg';
import './index.css';
import { store } from '../../../redux/store';
import Language from '../../../i18n/Language';
const t = Language;


class PageNotFound extends Component {

  render() {

    const pageContent = <div className='not_page'>
      <div className="page-not-found">
        <div className="not-found-title">
          {t("The page you're looking for couldn't be found")}
        </div>
        <div className="not-found-msg">
          {t("Check the web address and try again, or try navigating to the page from SEOWILL Home.")}
        </div>
        <Button variant="primary" size="large" url="/dashboard">{t("Go to SEOWILL Home")}</Button>
      </div>
      <div className="not-img">
        <img src={notFoundImg} alt="page not found" className="not-found-img"></img>
      </div>
    </div>;

    const embed = store.getState().public.isShowTopMenu;

    return (
      <div id="SEOpage_content" style={{ paddingLeft: `${window.isExpandedNav && embed ? '15rem' : '3.8rem'}`, maxWidth: '100%' }}>
        <title>SEOWILL - 404</title>
        <Page>
          <Card>{pageContent}</Card>
        </Page>
      </div>
    );
  }
}

export default PageNotFound;
